import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useUserStore = create(
    persist(
        (set) => {
            return {
                userInfo: null,
                loginAction: (data) => set((state) => ({ userInfo: data })),
                logoutAction: () => set({ userInfo: null }),
            }
        }, { name: "userInfo" }
    )
)

export const useAdminStore = create(
    persist(
        (set) => {
            return {
                adminInfo: null,
                adminLoginAction: (data) => set((state) => ({ adminInfo: data })),
                adminLogoutAction: () => set({ adminInfo: null }),
            }
        }, {name: "adminInfo"}
    )
)
// 😢 useAdminStore